if (!customElements.get('product-crossell-custom')) {
  class ProductCrossellCustom extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-variant-select]');
      this.mediaEl = this.querySelector('.horizontal-product__media');
      this.img = this.mediaEl?.querySelector('img');
      this.idInput = this.querySelector('input[name="id"]');
      this.submitBtn = this.querySelector('button[type="submit"]');
      this.priceEl = this.querySelector('.price');

      if (this.select) {
        this.select.addEventListener('change', this.onVariantChange.bind(this));
      }
    }

    onVariantChange() {
      const opt = this.select.selectedOptions[0];
      if (!opt) return;

      if (this.idInput) this.idInput.value = opt.value;

      if (this.submitBtn) {
        this.submitBtn.dataset.variantId = opt.value;
        this.submitBtn.disabled = opt.disabled;
      }

      if (this.img && opt.dataset.image && opt.dataset.image !== 'null') {
        this.mediaEl.classList.add('loading');
        this.img.src = opt.dataset.image;
        this.img.srcset = opt.dataset.image;
        this.img.addEventListener('load', () => this.mediaEl.classList.remove('loading'), { once: true });
        this.img.addEventListener('error', () => this.mediaEl.classList.remove('loading'), { once: true });
      }

      if (this.priceEl) {
        const price = opt.dataset.price;
        const compareAtPrice = opt.dataset.compareAtPrice;
        const onSale = Boolean(compareAtPrice);

        const regularEl = this.priceEl.querySelector('.price__regular');
        let saleEl = this.priceEl.querySelector('.price__sale');

        if (regularEl) regularEl.textContent = price;

        if (onSale) {
          this.priceEl.classList.add('price--on-sale');
          if (!saleEl) {
            saleEl = document.createElement('span');
            saleEl.className = 'price__sale inline-flex items-center h-auto relative';
            this.priceEl.appendChild(saleEl);
          }
          saleEl.textContent = compareAtPrice;
        } else {
          this.priceEl.classList.remove('price--on-sale');
          if (saleEl) saleEl.remove();
        }
      }
    }
  }

  customElements.define('product-crossell-custom', ProductCrossellCustom);
}
